import AddCreditNotePage from 'src/pages/AddCreditNotePage';
import AddMccPage from 'src/pages/AddMccPage';
import AddMerchantPage from 'src/pages/AddMerchantPage';
import AddOnlinePricingPage from 'src/pages/AddOnlinePricingPage';
import AddPartnerPage from 'src/pages/AddPartnerPage';
import AddProductPage from 'src/pages/AddProductPage';
import AddSalesInvoicePage from 'src/pages/AddSalesInvoicePage';
import AddServicePage from 'src/pages/AddServicePage';
import AddTerminalPricingPage from 'src/pages/AddTerminalPricingPage';
import AddTransactionPricingPage from 'src/pages/AddTransactionPricingPage';
import AddUserPage from 'src/pages/AddUserPage';
import AddUserRolePage from 'src/pages/AddUserRolePage';
import AuditLogPage from 'src/pages/AuditLogPage';
import CancellationReasonsPage from 'src/pages/CancellationReasonsPage';
import DirectDebitsPage from 'src/pages/DirectDebitsPage';
import EditMCCPage from 'src/pages/EditMCCPage';
import EditOnlinePricingPage from 'src/pages/EditOnlinePricingPage';
import EditProductPage from 'src/pages/EditProductPage';
import EditTerminalPricingPage from 'src/pages/EditTerminalPricingPage';
import EditUserPage from 'src/pages/EditUserPage';
import EditUserRolePage from 'src/pages/EditUserRolePage';
import HomePage from 'src/pages/HomePage';
import LoginPage from 'src/pages/LoginPage';
import MerchantApplicationPage from 'src/pages/MerchantApplicationPage';
import MerchantApplicationsPage from 'src/pages/MerchantApplicationsPage';
import PartnersPage from 'src/pages/PartnersPage';
import ProfilePage from 'src/pages/ProfilePage';
import RemoveStockReasonsPage from 'src/pages/RemoveStockReasonsPage';
import ResetPasswordPage from 'src/pages/ResetPasswordPage';
import RolesPage from 'src/pages/RolesPage';
import SuspendedReasonsPage from 'src/pages/SuspendedReasonsPage';
import TransactionPricingPage from 'src/pages/TransactionPricingPage';
import UserManagementPage from 'src/pages/UserManagementPage';
import VerificationPage from 'src/pages/VerificationPage';
import ViewCommissionStatementPage from 'src/pages/ViewCommissionStatementPage';
import ViewCreditNotePage from 'src/pages/ViewCreditNotePage';
import ViewCreditsPage from 'src/pages/ViewCreditsPage';
import ViewMCCPage from 'src/pages/ViewMCCPage';
import ViewMerchantPage from 'src/pages/ViewMerchantPage';
import ViewMerchantsPage from 'src/pages/ViewMerchantsPage';
import ViewOnlineCommissionsPage from 'src/pages/ViewOnlineCommissionsPage';
import ViewOnlinePricingPage from 'src/pages/ViewOnlinePricingPage';
import ViewPartnerPage from 'src/pages/ViewPartnerPage';
import ViewPartnerShopPage from 'src/pages/ViewPartnerShopPage';
import ViewSalesInvoicePage from 'src/pages/ViewSalesInvoicePage';
import ViewSalesInvoicesPage from 'src/pages/ViewSalesInvoicesPage';
import ViewSelfBillingInvoicePage from 'src/pages/ViewSelfBillingInvoicePage';
import ViewSelfBillingInvoicesPage from 'src/pages/ViewSelfBillingInvoicesPage';
import ViewTerminalCommissionsPage from 'src/pages/ViewTerminalCommissionsPage';
import ViewTerminalPricingsPage from 'src/pages/ViewTerminalPricingsPage';
import ViewTransactionCommissionsPage from 'src/pages/ViewTransactionCommissionsPage';
import ViewTransactionPricingPage from 'src/pages/ViewTransactionPricingPage';

import MCCPage from './pages/MccPage/MccPage';

export const routes = [
    { path: '/', element: HomePage },
    { path: '/login', element: LoginPage },
    { path: '/reset-password/:resetToken', element: ResetPasswordPage },
    { path: '/verification', element: VerificationPage },
    { path: '/user-management/users', element: UserManagementPage },
    { path: '/user-management/users/:id', element: EditUserPage },
    { path: '/user-management/add-user', element: AddUserPage },
    { path: '/user-management/user-roles', element: RolesPage },
    { path: '/user-management/add-user-role', element: AddUserRolePage },
    { path: '/user-management/view-user-role', element: EditUserRolePage },
    { path: '/partners', element: PartnersPage },
    { path: '/partner/add', element: AddPartnerPage },
    { path: '/partner/:id', element: ViewPartnerPage },
    { path: '/profile', element: ProfilePage },
    { path: '/profile/:code', element: ProfilePage },
    { path: '/mccs', element: MCCPage },
    { path: '/mccs/add', element: AddMccPage },
    { path: '/mccs/:id', element: ViewMCCPage },
    { path: '/mccs/:id/edit', element: EditMCCPage },
    { path: '/merchant/add', element: AddMerchantPage },
    { path: '/online-pricing', element: ViewOnlinePricingPage },
    { path: '/online-pricing/add', element: AddOnlinePricingPage },
    { path: '/online-pricing/:id/edit', element: EditOnlinePricingPage },
    { path: '/products/add', element: AddProductPage },
    { path: '/products/:id/edit', element: EditProductPage },
    { path: '/terminal-pricing', element: ViewTerminalPricingsPage },
    { path: '/terminal-pricing/add', element: AddTerminalPricingPage },
    { path: '/terminal-pricing/:id/edit', element: EditTerminalPricingPage },
    { path: '/merchant-applications/view', element: MerchantApplicationsPage },
    { path: '/merchant/:applicationId/add-service', element: AddServicePage },
    { path: '/merchants', element: ViewMerchantsPage },
    { path: '/merchant/:id', element: ViewMerchantPage },
    { path: '/config/cancellation-reasons', element: CancellationReasonsPage },
    { path: '/config/suspended-reasons', element: SuspendedReasonsPage },
    { path: '/config/remove-stock-reasons', element: RemoveStockReasonsPage },
    { path: '/merchant-applications/view-application/:id', element: MerchantApplicationPage },
    { path: '/config/audit-log', element: AuditLogPage },
    { path: '/transaction-pricing', element: TransactionPricingPage },
    { path: '/transaction-pricing/:id', element: ViewTransactionPricingPage },
    { path: '/add-transaction-pricing', element: AddTransactionPricingPage },
    { path: '/finance/sales-invoices', element: ViewSalesInvoicesPage },
    { path: '/finance/sales-invoice/:id', element: ViewSalesInvoicePage },
    { path: '/finance/sales-invoices/add', element: AddSalesInvoicePage },
    { path: '/finance/commissions/:commissionType/:id', element: ViewCommissionStatementPage },
    { path: '/finance/commissions/online', element: ViewOnlineCommissionsPage },
    { path: '/finance/commissions/terminal', element: ViewTerminalCommissionsPage },
    { path: '/finance/commissions/transaction', element: ViewTransactionCommissionsPage },
    { path: '/finance/self-billing-invoices', element: ViewSelfBillingInvoicesPage },
    { path: '/finance/self-billing-invoices/:id', element: ViewSelfBillingInvoicePage },
    { path: '/finance/credits', element: ViewCreditsPage },
    { path: '/finance/credits/add', element: AddCreditNotePage },
    { path: '/finance/credits/:id', element: ViewCreditNotePage },
    { path: '/finance/direct-debits', element: DirectDebitsPage },
    { path: '/partner-shops', element: ViewPartnerShopPage },
];

export const basename = '/';
